(() => {
  if (window.slPosterRewardsPickerInitialized) return;
  window.slPosterRewardsPickerInitialized = true;

  const pickerSelector = '[data-sl-gift-picker]';
  const tierConfig = {
    couche: { unlocked: 'coucheUnlocked', count: 'coucheCount', limit: 'coucheLimit' },
    metal: { unlocked: 'metalUnlocked', count: 'metalCount', limit: 'metalLimit' },
  };
  const tierCopy = {
    couche: {
      subtitle: 'COUCHÉ · Selecciona 2 diseños y el tamaño de cada uno.',
    },
    metal: {
      subtitle: 'ALUMINIO · Selecciona 1 diseño en formato 40×60 cm.',
    },
  };

  const roots = () => [...document.querySelectorAll(pickerSelector)];
  const rootFor = (element) => element.closest(pickerSelector);
  const isTrue = (value) => String(value) === 'true';
  const getTierConfig = (tier) => tierConfig[tier];
  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('es')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const statusFor = (root, tier) => root.querySelector(`[data-sl-gift-status="${tier}"]`);
  const setStatus = (root, tier, text) => {
    const status = statusFor(root, tier);
    if (status) status.textContent = text;
  };

  const selectedOptions = (root, tier) => [...root.querySelectorAll(`[data-sl-gift-option][data-tier="${tier}"][aria-pressed="true"]`)]
    .filter((option) => option.dataset.existing !== 'true');

  const stateFor = (root, tier) => {
    const config = getTierConfig(tier);
    const unlocked = isTrue(root.dataset[config.unlocked]);
    const count = Number(root.dataset[config.count] || 0);
    const limit = Number(root.dataset[config.limit] || 0);
    return { unlocked, count, limit, available: Math.max(0, limit - count) };
  };

  const refreshCard = (element, tier) => {
    const card = element.matches?.('[data-sl-gift-card]') ? element : element.closest('[data-sl-gift-card]');
    if (!card) return;
    const activeTier = tier || element.dataset?.tier || card.closest('[data-sl-gift-modal]')?.dataset.activeTier || 'couche';
    const hasSelection = [...card.querySelectorAll(`[data-sl-gift-option][data-tier="${activeTier}"]`)]
      .some((choice) => choice.getAttribute('aria-pressed') === 'true');
    card.classList.toggle('is-selected', hasSelection);
  };

  const refreshTier = (root, tier) => {
    const { unlocked, available } = stateFor(root, tier);
    const chosen = selectedOptions(root, tier);
    const button = root.querySelector(`[data-sl-gift-add="${tier}"]`);
    const label = root.querySelector(`[data-sl-gift-add-label="${tier}"]`);
    const opener = root.querySelector(`[data-sl-tier-open-label="${tier}"]`);

    if (opener) {
      opener.textContent = available === 0
        ? 'RECOMPENSA AGREGADA'
        : tier === 'couche'
          ? `ELEGIR ${available} POSTER${available === 1 ? '' : 'S'}`
          : 'ELEGIR POSTER';
    }

    if (!button || !label) return;

    if (!unlocked) {
      button.disabled = true;
      label.textContent = 'BENEFICIO BLOQUEADO';
      return;
    }

    if (available === 0) {
      button.disabled = true;
      label.textContent = 'RECOMPENSA AGREGADA';
      return;
    }

    if (chosen.length === available) {
      button.disabled = false;
      label.textContent = tier === 'couche'
        ? `AGREGAR ${available} POSTER${available === 1 ? '' : 'S'} COUCHÉ`
        : 'AGREGAR POSTER METÁLICO 40×60';
      return;
    }

    button.disabled = true;
    const remaining = Math.max(0, available - chosen.length);
    label.textContent = tier === 'couche'
      ? `ELIGE ${remaining} POSTER${remaining === 1 ? '' : 'S'} MÁS`
      : 'ELIGE TU POSTER 40×60';
  };

  const refreshPicker = (root) => {
    refreshTier(root, 'couche');
    refreshTier(root, 'metal');
    const modal = root.querySelector('[data-sl-gift-modal]');
    const activeTier = modal?.dataset.activeTier || 'couche';
    root.querySelectorAll('[data-sl-gift-card]').forEach((card) => refreshCard(card, activeTier));
  };

  const eligibleForTier = (card, tier) => card.dataset[`has${tier.charAt(0).toUpperCase()}${tier.slice(1)}`] === 'true';

  const filterCards = (modal, resetPosition = false) => {
    const tier = modal.dataset.activeTier || 'couche';
    const input = modal.querySelector('[data-sl-gift-search]');
    const query = normalize(input?.value);
    const cards = [...modal.querySelectorAll('[data-sl-gift-card]')];
    let visible = 0;

    cards.forEach((card) => {
      const matchesTier = eligibleForTier(card, tier);
      const matchesSearch = !query || normalize(card.dataset.search).includes(query);
      const show = matchesTier && matchesSearch;
      card.hidden = !show;
      if (show) visible += 1;
    });

    const results = modal.querySelector('[data-sl-gift-results]');
    const empty = modal.querySelector('[data-sl-gift-empty]');
    if (results) results.textContent = String(visible);
    if (empty) empty.hidden = visible !== 0;
    if (resetPosition) modal.querySelector('[data-sl-carousel]')?.scrollTo({ left: 0, behavior: 'auto' });
  };

  const switchMaterial = (root, modal, tier, resetPosition = true) => {
    const { unlocked } = stateFor(root, tier);
    if (!unlocked || !modal) return;

    modal.dataset.activeTier = tier;
    const subtitle = modal.querySelector('[data-sl-gift-modal-subtitle]');
    if (subtitle) subtitle.textContent = tierCopy[tier].subtitle;

    modal.querySelectorAll('[data-sl-material-tab]').forEach((tab) => {
      const active = tab.dataset.slMaterialTab === tier;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    modal.querySelectorAll('[data-sl-gift-card]').forEach((card) => refreshCard(card, tier));
    setStatus(root, tier, '');
    refreshTier(root, tier);
    filterCards(modal, resetPosition);
  };

  const openModal = (root, tier, opener) => {
    const { unlocked } = stateFor(root, tier);
    const modal = root.querySelector('[data-sl-gift-modal]');
    if (!unlocked || !modal) return;

    modal.dataset.returnFocus = tier;
    const search = modal.querySelector('[data-sl-gift-search]');
    if (search) search.value = '';

    switchMaterial(root, modal, tier, true);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    opener?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('sl-gift-modal-open');

    window.requestAnimationFrame(() => {
      const focusTarget = modal.querySelector('[data-sl-gift-search]') || modal.querySelector('[data-sl-gift-modal-close]');
      focusTarget?.focus({ preventScroll: true });
    });
  };

  const closeModal = (modal) => {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    const root = rootFor(modal);
    const tier = modal.dataset.returnFocus;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sl-gift-modal-open');

    const opener = root?.querySelector(`[data-sl-gift-modal-open="${tier}"]`);
    opener?.setAttribute('aria-expanded', 'false');
    opener?.focus({ preventScroll: true });
  };

  const refreshSection = async (root) => {
    const sectionId = root.dataset.sectionId;
    const cartUrl = root.dataset.cartUrl || '/cart';
    if (!sectionId) return;

    const endpoint = new URL(cartUrl, window.location.origin);
    endpoint.searchParams.set('section_id', sectionId);
    const response = await fetch(endpoint.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) return;

    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector(pickerSelector);
    if (replacement) root.replaceWith(replacement);
  };

  const refreshAllSections = () => Promise.all(roots().map((root) => refreshSection(root).catch(() => null)));

  const readCart = async () => {
    const response = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No se pudo actualizar el carrito.');
    return response.json();
  };

  const enforceEligibility = async (root) => {
    if (!isTrue(root.dataset.autoRemoveInvalid)) return;

    try {
      const cart = await readCart();
      const apparelQuantity = cart.items.reduce((total, item) => total + (item.product_type === 'PLAYERA' ? item.quantity : 0), 0);
      const updates = {};

      cart.items.forEach((item) => {
        const tier = item.properties?._sl_reward_tier;
        if ((tier === 'couche' && apparelQuantity < 3) || (tier === 'metal' && apparelQuantity < 6)) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) return;

      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });

      if (response.ok) window.location.reload();
    } catch (_) {
      // El carrito conserva su comportamiento nativo si no puede verificarse la elegibilidad.
    }
  };

  document.addEventListener('input', (event) => {
    const search = event.target.closest('[data-sl-gift-search]');
    if (!search) return;
    const modal = search.closest('[data-sl-gift-modal]');
    if (modal) filterCards(modal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('[data-sl-gift-modal][aria-hidden="false"]');
    if (modal) closeModal(modal);
  });

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-sl-gift-modal-open]');
    if (openButton) {
      const root = rootFor(openButton);
      if (root) openModal(root, openButton.dataset.slGiftModalOpen, openButton);
      return;
    }

    const closeButton = event.target.closest('[data-sl-gift-modal-close]');
    if (closeButton) {
      closeModal(closeButton.closest('[data-sl-gift-modal]'));
      return;
    }

    const materialTab = event.target.closest('[data-sl-material-tab]');
    if (materialTab) {
      const root = rootFor(materialTab);
      const modal = materialTab.closest('[data-sl-gift-modal]');
      const tier = materialTab.dataset.slMaterialTab;
      if (root && modal && tier && !materialTab.disabled) switchMaterial(root, modal, tier, true);
      return;
    }

    const carouselButton = event.target.closest('[data-sl-carousel-prev], [data-sl-carousel-next]');
    if (carouselButton) {
      const modal = carouselButton.closest('[data-sl-gift-modal]');
      const track = modal?.querySelector('[data-sl-carousel]');
      const visibleCard = track ? [...track.querySelectorAll('[data-sl-gift-card]:not([hidden])')][0] : null;
      if (!track || !visibleCard) return;
      const styles = window.getComputedStyle(track);
      const columnGap = Number.parseFloat(styles.columnGap);
      const shorthandGap = Number.parseFloat(styles.gap);
      const gap = Number.isFinite(columnGap) ? columnGap : Number.isFinite(shorthandGap) ? shorthandGap : 0;
      const distance = visibleCard.getBoundingClientRect().width + gap;
      const direction = carouselButton.hasAttribute('data-sl-carousel-prev') ? -1 : 1;
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      return;
    }

    const option = event.target.closest('[data-sl-gift-option]');
    if (option) {
      const root = rootFor(option);
      const tier = option.dataset.tier;
      if (!root || !tier || option.dataset.existing === 'true') return;

      const { unlocked, available } = stateFor(root, tier);
      if (!unlocked || available === 0) return;

      const isSelected = option.getAttribute('aria-pressed') === 'true';
      const selected = selectedOptions(root, tier);
      if (!isSelected && selected.length >= available) {
        setStatus(root, tier, `Ya elegiste ${available} poster${available === 1 ? '' : 's'}. Quita uno para cambiarlo.`);
        return;
      }

      option.setAttribute('aria-pressed', String(!isSelected));
      option.classList.toggle('is-selected', !isSelected);
      refreshCard(option, tier);
      setStatus(root, tier, '');
      refreshTier(root, tier);
      return;
    }

    const addButton = event.target.closest('[data-sl-gift-add]');
    if (!addButton) return;

    const root = rootFor(addButton);
    const tier = addButton.dataset.slGiftAdd;
    if (!root || !tier || addButton.disabled) return;

    const { available } = stateFor(root, tier);
    const chosen = selectedOptions(root, tier).map((option) => option.dataset.variantId).filter(Boolean);
    if (chosen.length !== available) {
      setStatus(root, tier, `Elige ${available} poster${available === 1 ? '' : 's'} para continuar.`);
      refreshTier(root, tier);
      return;
    }

    const original = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'AGREGANDO...';
    setStatus(root, tier, 'Agregando tu recompensa y aplicando el descuento...');

    try {
      const rewardLabel = tier === 'couche'
        ? '2 posters couche · Promo 3 playeras'
        : 'Poster metálico 40×60 · Promo 6 playeras';

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: chosen.map((id) => ({
            id: Number(id),
            quantity: 1,
            properties: {
              _sl_reward: 'true',
              _sl_reward_tier: tier,
              _sl_reward_label: rewardLabel,
            },
          })),
        }),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'No fue posible agregar el regalo.');

      window.location.reload();
    } catch (error) {
      setStatus(root, tier, error.message || 'No fue posible agregar el regalo. Intenta de nuevo.');
      addButton.textContent = original;
      refreshTier(root, tier);
    }
  });

  const initialize = () => {
    roots().forEach((root) => {
      refreshPicker(root);
      enforceEligibility(root);
    });
  };

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(() => refreshAllSections(), 120));
  }

  document.addEventListener('DOMContentLoaded', initialize);
  initialize();
})();
